










import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'
import { Hooks } from '@/shared/interfaces/hooks'
import { enhanceVideoPlayers } from '@/shared/utils/enhance-video-players'
import RespondecoEditorLiveView from '@/shared/components/respondeco-editor-live-view.vue'
import { environmentConfiguration } from '@/config/environments'

@Component({
  name: 'project-description',
  components: { RespondecoEditorLiveView },
})
export default class ProjectDescription extends Vue implements Hooks {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly project!: ProjectViewModel

  branding = environmentConfiguration().branding

  mounted() {
    enhanceVideoPlayers('.project-description video')
  }
}
